import { ComponentSettingsKpiChartMeasureField } from '@report-content';
import { Highcharts } from 'components/chart/Chart';
import { SeriesMeasurementId, SeriesPrimaryId } from './index';

export interface IKpiMeasurePointData {
    color: string;
    name_f: string;
    x_f: string;
    y_f: string;
}

export function getMeasurementSeries(
    measureField: ComponentSettingsKpiChartMeasureField,
    enabled: boolean,
    index: number,
    isVisible: boolean,
): Highcharts.SeriesLineOptions {
    const isPrimary = measureField.is_primary == 'Y';
    const seriesType =
        measureField.display_type && -1 !== ['line', 'area', 'column'].indexOf(measureField.display_type ?? '')
            ? measureField.display_type
            : 'line';
    return {
        //@ts-ignore
        type: seriesType,
        name: measureField.column_name,
        id: isPrimary ? SeriesPrimaryId : `${SeriesMeasurementId}_${index}`,
        dataLabels: {
            enabled: enabled,
            padding: 3,
            borderRadius: 3,
            backgroundColor: seriesType == 'line' ? 'none' : 'rgba(255, 255, 255, 0.6)',
            style: {
                color: '#222',
                textOutline: 'none',
            },
        },
        color: measureField.color,
        data: [],
        visible: isVisible,
    };
}
